export default __webpack_public_path__ + "static/media/ProfilePlaceholder.157f088b.png";